import { render, staticRenderFns } from "./Active.vue?vue&type=template&id=612932fa&scoped=true&"
import script from "./Active.vue?vue&type=script&lang=ts&"
export * from "./Active.vue?vue&type=script&lang=ts&"
import style0 from "./Active.vue?vue&type=style&index=0&id=612932fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612932fa",
  null
  
)

export default component.exports